import React from 'react';
import { useSelector } from 'react-redux';
import { Layout, Row, Col, Empty } from 'antd';
import TitleAndNew from '../Components/TitleAndNew/TitleAndNew';
import ProjectTabs from '../Components/ProjectTabs/ProjectTabs';
import DynamicTable from '../Components/DynamicTable/DynamicTable';

const { Content } = Layout;

const UserProjects = () => {
  const currentProject = useSelector((state) => state.currentProject);
  return (
    <Layout>
      <Content style={{ margin: '36px', minHeight: '80vh' }}>
        <TitleAndNew titleText={'Projekty'} />
        <Row gutter={16}>
          <Col span={7}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              <DynamicTable type={'projects'} userView />
            </div>
          </Col>
          <Col span={17}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              {currentProject.id || currentProject.newProject ? (
                <ProjectTabs userView />
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={<span>Wybierz</span>}
                />
              )}
            </div>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default UserProjects;
